import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Checkbox, Container, Segment, Sticky, Grid, Input, Transition, Dimmer, Loader } from 'semantic-ui-react';
import { Button, Form, Icon, Label, List } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import { AppState } from '../context';
import DatetoTime from '../DatetoTime';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { dbFamMember, dbCaregivers, dbTasks, dbFamtoFam } from '../firebase';
import TopMenu from './TopMenu';
import Name from './ProfileCreation/Name';


const TaskList = ({ userID }) => {
  const someContext = useContext(AppState);
  const [famtofam, setFamtofam] = useState("")
  const [familyMembers, setFamilyMembers] = useState([])
  const [myTasksFromFam, setMyTasks] = useState([]);
  const sendText = firebase.functions().httpsCallable('sendText');

  function sendSMSCaregiver(taskID) {

    var number2 = "";
    dbTasks.child(taskID).once('value').then(function (temp) {
      var taskname = temp.val().taskName
      var duration = temp.val().duration
      var description = temp.val().description;
      var time = temp.val().time;
      var importance = temp.val().importance;
      var freq = temp.val().frequency;


      var c = "Task: " + taskname + " at approximately " + time + "Description: " + description + "Importance: "
        + importance + "Frequency: " + freq;
      console.log(c)

      dbCaregivers.child(temp.val().caregiverId).child("phone").once("value", function (snapshot) {
        number2 = snapshot.val()

      }, function (errorObject) {
        console.log("The read failed: " + errorObject.code);
      });
      let tempe = { to: number2, body: c };
      console.log(tempe)
      sendText({ data: tempe });
    });
  }
  function sendSMSFamilyMember(taskID) {
    var number2 = "";
    dbFamtoFam.child(taskID).once('value').then(function (temp) {
      var taskname = temp.val().taskName
      var description = temp.val().description;
      var time = temp.val().time;
      var importance = temp.val().importance;
      var freq = temp.val().frequency;


      var c = "Task: " + taskname + " at approximately " + time + "Description: " + description + "Importance: "
        + importance + "Frequency: " + freq;
      console.log(c)

      dbFamtoFam.child(temp.val().AssignedtoFam).child("phone").once("value", function (snapshot) {
        number2 = snapshot.val()

      }, function (errorObject) {
        console.log("The read failed: " + errorObject.code);
      });
      let tempe = { to: number2, body: c };
      console.log(tempe)
      sendText({ data: tempe });
    });

  }


  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) {
        setFamilyMembers(snap.val());
        if (snap.val()[userID] && snap.val()[userID]["tasksfromfam"]) {
          setMyTasks(Object.values(snap.val()[userID]["tasksfromfam"]))
        }
      }
    }
    dbFamMember.on('value', handleData, error => alert(error));
    return () => { dbFamMember.off('value', handleData); };
  }, []);

  useEffect(() => {
    const handleData = snap => {
      if (snap.val()) {
        setFamtofam(snap.val());
      }
    }
    dbFamtoFam.on('value', handleData, error => alert(error));
    return () => { dbFamtoFam.off('value', handleData); };
  }, []);
  const withMenu = (page) => {
    return (
      <Container>
        <TopMenu />
        {page}
      </Container>
    )
  };
  const {
    months,
    caregivers,
    tasks,
    seniors,
  } = someContext;
  const contextRef = createRef();
  const [checkloader, setCheckLoader] = useState(false);
  const [todayDate, setDate]=useState(new Date())
  const [todayString, setTodayString]=useState(todayDate.toString())
  var temploader = false;
  function Tasks() {
    const [carelist, setCarelist] = useState([])

    function Refreshoncheck() {
      setCheckLoader(true);
      setTimeout(() => { setCheckLoader(true); }, 2000)
    }
    useEffect(() => {
      const handleClose = () => {
        if (familyMembers && familyMembers[userID] && familyMembers[userID]["tasks"] && caregivers && familyMembers[userID]["careBool"] ) {
          let b = Object.values(familyMembers[userID]["caregivers"]);
          let arr = []
          for (let j = 0; j < b.length; j++) {
            let c = caregivers[b[j]]["todolist"];
            const result1 = Object.values(c);
            const id = Object.keys(c);
            for (let i = 0; i < result1.length; i++) {
              arr.push([id[i], result1[i], b[j]]);
            }
          }
          setCarelist(arr);
        }
      };
      handleClose();
    }, []);


    function Update_click(status) {
      Refreshoncheck();
      if (status[1]["detail"] && status[0] && status[2]) {
        let new_status = !status[1]["status"];
        dbCaregivers.child(status[2]).child("todolist").child(status[0]).update({
          "status": new_status,
          "statusLastChecked": { '.sv': 'timestamp' }
        })
      }
    }

    function Update_clickFam(id) {
      Refreshoncheck();
      let new_status = !famtofam[id]["status"];
      dbFamtoFam.child(id).update({
        "status": new_status,
        "statusLastChecked": { '.sv': 'timestamp' }
      })
    }

    function helper1(input) {
      if (!input[1]["sample"]) {
        let temp;
        if (!input[1]["status"]) {
          temp = DatetoTime(input[1]["createdOn"]);
          return (
            <List.Item>
              <List.Icon>
                <Checkbox checked={input[1]["status"]} onClick={() => Update_click(input)} />
              </List.Icon>
              <List.Content>
                {/* <List.Description>
                  <Button icon="share" size="mini" floated="right" onClick={() => sendSMSCaregiver(input)}>
                  </Button>
                </List.Description> */}
                <List.Header as="a">{input[1]["type"] + ": " + input[1]["detail"]}</List.Header>
                <List.Description as="a">
                  <strong> Created on: </strong> {temp}
                </List.Description>
              </List.Content>
              <List.Icon >

              </List.Icon>
            </List.Item>
          )
        }
      }
      else {
        return null;
      }
    }


    function helper2(input) {
      let temp;
      let temp1;
      if (caregivers) {
        temp = DatetoTime(input[1]["statusLastChecked"]);
        temp1 = DatetoTime(input[1]["createdOn"]);
      }
      if (input[1]["status"]) {
        return (
          <List.Item>
            <List.Icon>
              <Checkbox checked={input[1]["status"]} onClick={() => Update_click(input)} />
            </List.Icon>
            <List.Content>
              <List.Description>
                {/* <Label as='a' attached="top right" color="green" size="mini" ribbon>
                  </Label> */}
              </List.Description>
              <List.Header as="a">{input[1]["type"] + ": " + input[1]["detail"]}</List.Header>
              <List.Description as="a">
                <strong> Created on: </strong> {temp1}
              </List.Description>
              <List.Description as="a">
                <strong> Completed on: </strong> {temp}
              </List.Description>
            </List.Content>
          </List.Item>

        )
      }
      else {
        return (null)
      }
    }

    function EachItemF1(id) {

      function testTodayy(){
        if(famtofam[id]['duebydate']){

        var date= new Date(famtofam[id]['duebydate']);
        var arry=date.toString().split(" ");
        console.log("this is the date")
        console.log(arry);
        console.log(todayString.toString().split(" "));
        if(arry[0]==todayString.split(" ")[0] && arry[1]==todayString.split(" ")[1] && arry[2]==todayString.split(" ")[2] && arry[3]==todayString.split(" ")[3]){
          console.log('correctomondo')
          return true;
        }
        var createdonDate=new Date(famtofam[id]['createdOn'])
        console.log(createdonDate)
        
        var todaystime= new Number(todayDate)
        var timedue=  new Number(famtofam[id]['duebydate'])
        console.log(todaystime);
        console.log(timedue);
        if(createdonDate.getDay() == todayDate.getDay() && famtofam[id]['frequency']=="Weekly" && todaystime>=timedue ){
          return true;
        }
        else if((famtofam[id]['frequency']==="Everyday" || famtofam[id]['frequency']==="Twice a Day" )&& todaystime>=timedue){
          return true;
        }
  
        else{
          return false;
        }
      }
    }
// && testTodayy()
      if ((familyMembers && familyMembers[userID] && (familyMembers[userID]["secondaryFam"] != "hi" || Object.values(familyMembers[userID]['tasksfromfam']).length>0)) ) {
        if (famtofam[id]["status"] && myTasksFromFam) {
          var temp;
          if (famtofam) {
            var temp = DatetoTime(famtofam[id]["statusLastChecked"]);
            var temp1 = DatetoTime(famtofam[id]["createdOn"]);
          }
          return (
            <List.Item>
              <List.Icon>
                <Checkbox checked={famtofam[id]["status"]} onClick={() => Update_clickFam(id)} />
              </List.Icon>
              <List.Content>
                <List.Header as="a">{famtofam[id]["taskName"] + ": "}</List.Header>
                <List.Description as="a">
                  <strong>Created on:</strong> {temp1}
                  {/* {familyMembers[famtofam[id]["AssignedbyFam"]]['firstName'] + " "} */}
                </List.Description>
                {/*tasks[input]["seniorFirstName"]*/}
                <List.Description as="a">
                  <strong>Completed on:</strong> {temp + " "}</List.Description>
                <List.Description>
                  <strong>Details:</strong>
                  {" " + famtofam[id]["description"]}</List.Description>
              </List.Content>
            </List.Item>
          );
        }
        else if (!famtofam[id]["status"] && myTasksFromFam) {

          var temp;
          if (famtofam) {
            temp = DatetoTime(famtofam[id]["createdOn"]);
          }
          return (
            <List.Item>
              <List.Icon>
                <Checkbox checked={famtofam[id]["status"]} onClick={() => Update_clickFam(id)} />
              </List.Icon>
              <List.Content>
                {/* <List.Description>
                  <Button icon="share" size="mini" floated="right" onClick={() => sendSMSFamilyMember(id)}>
                  </Button>
                </List.Description> */}
                <List.Header as="a">{famtofam[id]["taskName"] + ":"}</List.Header>
                <List.Description as="a">
                  <strong>Created on:</strong> {temp}
                  {/* {familyMembers[famtofam[id]["AssignedbyFam"]]['firstName'] + " "} */}
                </List.Description>
                <List.Description>
                  <strong>Details:</strong>
                  {" " + famtofam[id]["description"]}</List.Description>
              </List.Content>
            </List.Item>);
        }
      }
      else if (myTasksFromFam.length === 0) {
        return (
          <Header style={{ marginTop: '10px', marginBottom: '10px' }} as='h6' textAlign="center">None assigned as yet... lucky you!</Header>
        )
      }
      else{

      }
    }

    function EachItemF2(id) {
      function testToday(){
        if(famtofam[id]['duebydate']){

        var date= new Date(famtofam[id]['duebydate']);
        var arry=date.toString().split(" ");
        console.log("this is the date")
        console.log(arry);
        console.log(todayString.toString().split(" "));
        if(arry[0]==todayString.split(" ")[0] && arry[1]==todayString.split(" ")[1] && arry[2]==todayString.split(" ")[2] && arry[3]==todayString.split(" ")[3]){
          console.log('correctomondo')
          return true;
        }
        var createdonDate=new Date(famtofam[id]['createdOn'])
        console.log(createdonDate)
        
        var todaystime= new Number(todayDate)
        var timedue=  new Number(famtofam[id]['duebydate'])
        if(createdonDate.getDay() == todayDate.getDay() && famtofam[id]['frequency']=="Weekly" && todaystime>=timedue ){
          return true;
        }
        else if((famtofam[id]['frequency']==="Everyday" || famtofam[id]['frequency']==="Twice a Day" )&& todaystime>=timedue){
          return true;
        }
  
        else{
          return false;
        }
      }
    }

      if ((familyMembers && familyMembers[userID] && (familyMembers[userID]["secondaryFam"] != "hi" || Object.values(familyMembers[userID]['tasksfromfam']).length>0) && !testToday()) ) {
        if (famtofam[id]["status"] && myTasksFromFam) {
          var temp;
          if (famtofam) {
            var temp = DatetoTime(famtofam[id]["statusLastChecked"]);
            var temp1 = DatetoTime(famtofam[id]["createdOn"]);
          }
          return (
            <List.Item>
              <List.Icon>
                <Checkbox checked={famtofam[id]["status"]} onClick={() => Update_clickFam(id)} />
              </List.Icon>
              <List.Content>
                <List.Header as="a">{famtofam[id]["taskName"] + ": "}</List.Header>
                <List.Description as="a">
                  <strong>Created on:</strong> {temp1}
                  {/* {familyMembers[famtofam[id]["AssignedbyFam"]]['firstName'] + " "} */}
                </List.Description>
                {/*tasks[input]["seniorFirstName"]*/}
                <List.Description as="a">
                  <strong>Completed on:</strong> {temp + " "}</List.Description>
                <List.Description>
                  <strong>Details:</strong>
                  {" " + famtofam[id]["description"]}</List.Description>
              </List.Content>
            </List.Item>
          );
        }
        else if (!famtofam[id]["status"] && myTasksFromFam) {

          var temp;
          if (famtofam) {
            temp = DatetoTime(famtofam[id]["createdOn"]);
          }
          return (
            <List.Item>
              <List.Icon>
                <Checkbox checked={famtofam[id]["status"]} onClick={() => Update_clickFam(id)} />
              </List.Icon>
              <List.Content>
                {/* <List.Description>
                  <Button icon="share" size="mini" floated="right" onClick={() => sendSMSFamilyMember(id)}>
                  </Button>
                </List.Description> */}
                <List.Header as="a">{famtofam[id]["taskName"] + ":"}</List.Header>
                <List.Description as="a">
                  <strong>Created on:</strong> {temp}
                  {/* {familyMembers[famtofam[id]["AssignedbyFam"]]['firstName'] + " "} */}
                </List.Description>
                <List.Description>
                  <strong>Details:</strong>
                  {" " + famtofam[id]["description"]}</List.Description>
              </List.Content>
            </List.Item>);
        }
      }
      else{
        return "";
      }
    }
   

    if(familyMembers && familyMembers[userID] && familyMembers[userID]["secondaryFam"]!=="hi" || familyMembers && familyMembers[userID] &&  familyMembers[userID]['careBool']!==false || familyMembers && familyMembers[userID] && familyMembers[userID]['tasksfromfam'] && Object.values(familyMembers[userID]['tasksfromfam']).length>0){
    
      return (
     <List divided relaxed selection animated>
        {familyMembers ? carelist.map((input) => helper1(input)) : ""}
        {familyMembers ? carelist.map((input) => helper2(input)) : ""}
        {famtofam ? myTasksFromFam.map((input) => EachItemF1(input)) : ""}
        {/* {famtofam ? myTasksFromFam.map((input) => EachItemF2(input)) : ""} */}

      </List>

      

    );
  }
  else{
    return(null
    //<div> Add a caregiver or another family member through your profile page, and whenever they have a task for you it'll pop up here!</div>
    );
  }


  }
  return(
    <Tasks />
  )
  
  
}
export default TaskList;